export default __webpack_public_path__ + "static/media/network-graph-1-lqMAX.2d15ae7c.jpg";